/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreateCustomerSessionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateCustomerSessionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type CreateCustomerSessionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateCustomerSessionSecurity$outboundSchema: z.ZodMiniType<
  CreateCustomerSessionSecurity$Outbound,
  CreateCustomerSessionSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createCustomerSessionSecurityToJSON(
  createCustomerSessionSecurity: CreateCustomerSessionSecurity,
): string {
  return JSON.stringify(
    CreateCustomerSessionSecurity$outboundSchema.parse(
      createCustomerSessionSecurity,
    ),
  );
}

/** @internal */
export type CreateCustomerSessionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateCustomerSessionRequest$outboundSchema: z.ZodMiniType<
  CreateCustomerSessionRequest$Outbound,
  CreateCustomerSessionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function createCustomerSessionRequestToJSON(
  createCustomerSessionRequest: CreateCustomerSessionRequest,
): string {
  return JSON.stringify(
    CreateCustomerSessionRequest$outboundSchema.parse(
      createCustomerSessionRequest,
    ),
  );
}
